const observer = new MutationObserver(function (mutations_list) {
  mutations_list.forEach(function (mutation) {
    if (mutation.addedNodes.length) {
      // creat times icon
      const formGroup = document.querySelector(".stockist-query-entry");

      timesIcon = document.createElement("span");
      timesIcon.setAttribute("class", "times-icon");

      formGroup.appendChild(timesIcon);

      //   reset input
      const inputElement = document.querySelector(
        "input.stockist-search-field"
      );

      if (timesIcon && inputElement) {
        timesIcon.addEventListener("click", () => {
          inputElement.value = " ";
        });
      }

      // set position for toggle tab
      const getHeightForm = document.querySelector(
        ".stockist-search-form"
      ).clientHeight;
      const toggleMap = document.querySelector(".toggle-map");
      toggleMap.style.top = `${getHeightForm}px`;

      // toggle tab
      const toggleTabs = document.querySelectorAll(".js-toggle-tab");
      const contents = document.querySelectorAll(".stockist-horizontal > div");
      contents[0].classList.add("hide");

      toggleTabs.forEach((toggleTab, i) => {
        toggleTab.addEventListener("click", () => {
          toggleTabs.forEach((button) => button.classList.remove("active"));
          contents.forEach((content) => content.classList.remove("hide"));
          toggleTab.classList.add("active");
          contents[i].classList.add("hide");
        });
      });

      //   disconnect observer
      observer.disconnect();
    }
  });
});

var config = {
  attributes: false,
  childList: true,
  characterData: false,
};

observer.observe(document.querySelector("#map-wp"), config);
